'use strict';

import BaseModel from './baseModel';
import _ from 'lodash';

class DesignationsAndAssociations extends BaseModel {
  constructor(schema = designationsAndAssociationsSchema) {
    super(schema);
  }

  static getSchema() {
    return designationsAndAssociationsSchema;
  }
}

export const designationsAndAssociationsSchema = {
  ProfessionalDesignations: {
    custom: {
      func: val => !_.isEmpty(val),
      message: 'Must Select at Least One'
    }
  },
  ProfessionalAssociations: {
    custom: {
      func: val => !_.isEmpty(val),
      message: 'Must Select at Least One'
    }
  }
};

module.exports = DesignationsAndAssociations;



// WEBPACK FOOTER //
// ./shared/models/designationsAndAssociations.js